module.exports = __webpack_public_path__ + "csodacsapat2.jpg?14aba8ca359af9a0bdc41e2cb6bd7af8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/csodacsapat2.jpg
// module id = 75
// module chunks = 0